/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_Import_ColumnsInputs */



/**
* | output |
* | --- |
* | "Expected columns (header row required): vekn_id and/or email; optional: name, paid." |
*
* @param {Csv_Import_ColumnsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const csv_import_columns = /** @type {((inputs?: Csv_Import_ColumnsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_Import_ColumnsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Colonnes attendues (ligne d'en-tête requise) : vekn_id et/ou email ; optionnel : name, paid.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Columnas esperadas (fila de encabezado obligatoria): vekn_id y/o email; opcional: name, paid.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Colunas esperadas (linha de cabeçalho obrigatória): vekn_id e/ou email; opcional: name, paid.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Colonne previste (riga di intestazione obbligatoria): vekn_id e/o email; opzionale: name, paid.")
	return /** @type {LocalizedString} */ ("Expected columns (header row required): vekn_id and/or email; optional: name, paid.")
});